export enum Color {
  PRIMARY = '#007ca6',
  ACCENT = '#e44812',
  ANALOGOUS_1 = '#00a67d',
  ANALOGOUS_2 = '#002aa6',
  TRIADIC_1 = '#2a00a6',
  TRIADIC_2 = '#fd0091',
  DARK_GREY  = '#afafaf'
}
